import React, { useState } from 'react';
import api, { getApiErrorMessage } from '../api';
import ThemePicker from './ThemePicker';
import './EditPollModal.css';

const CreatePollModal = ({ onClose, onCreated, userTier }) => {
    const [title, setTitle] = useState('');
    const [description, setDescription] = useState('');
    const [showResults, setShowResults] = useState(true);
    const [theme, setTheme] = useState('light');
    const [loading, setLoading] = useState(false);

    const handleCreate = async () => {
        if (!title.trim()) {
            alert('Введите название опроса');
            return;
        }

        setLoading(true);
        try {
            const userRes = await api.get('/users/me');
            const teacherId = userRes.data.telegram_id;

            const res = await api.post('/polls/', {
                teacher_telegram_id: teacherId,
                title: title,
                description: description,
                show_results: showResults,
                theme,
                questions: []
            });

            onCreated(res.data);
            onClose();
        } catch (err) {
            console.error('Failed to create poll', err);
            const detail = getApiErrorMessage(err, 'Ошибка при создании опроса');
            const upgradeNote = err.response?.status === 403 ? '\n\nДля активации и редактирования опросов необходимо перейти на другой тариф.' : '';
            alert(detail + upgradeNote);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="app-modal-overlay" role="presentation" onClick={onClose}>
            <div className="app-modal" role="dialog" onClick={(e) => e.stopPropagation()}>
                <div className="app-modal__header">
                    <h2>Создание опроса</h2>
                    <button type="button" className="app-modal__close" onClick={onClose} aria-label="Закрыть">✕</button>
                </div>

                <div className="app-modal__body ep-create">
                    <label className="ep-field">
                        <span className="ep-field__label">Название опроса</span>
                        <input
                            id="create-poll-title"
                            className="form-input"
                            type="text"
                            value={title}
                            maxLength={500}
                            autoFocus
                            onChange={(e) => setTitle(e.target.value)}
                            onKeyDown={(e) => { if (e.key === 'Enter') handleCreate(); }}
                            placeholder="Например: Обратная связь по лекции №5"
                        />
                    </label>

                    <label className="ep-field">
                        <span className="ep-field__label">Описание <small>необязательно</small></span>
                        <textarea
                            id="create-poll-desc"
                            className="form-textarea"
                            value={description}
                            maxLength={5000}
                            onChange={(e) => setDescription(e.target.value)}
                            rows={2}
                            placeholder="Пара слов для участников: о чём опрос"
                        />
                    </label>

                    <label className={`ep-toggle${userTier === 'free' ? ' is-disabled' : ''}`}>
                        <input
                            type="checkbox"
                            role="switch"
                            checked={showResults}
                            onChange={(e) => setShowResults(e.target.checked)}
                            disabled={userTier === 'free'}
                        />
                        <span className="ep-toggle__track" aria-hidden />
                        <span className="ep-toggle__text">
                            <span>Показывать результаты после ответа</span>
                            <small>
                                {userTier === 'free'
                                    ? 'Отключить можно на тарифах «Расширенный» и «Корпоративный».'
                                    : showResults ? 'Участник сразу увидит графики.' : 'Участник увидит «Спасибо за участие!» без результатов.'}
                            </small>
                        </span>
                    </label>

                    <ThemePicker id="create-poll-theme" value={theme} onChange={setTheme} />

                    <p className="ep-create__note">
                        Дальше откроется редактор — добавьте вопросы. Опрос создаётся выключенным:
                        включите его, когда будете готовы показать QR-код участникам.
                    </p>
                </div>

                <div className="app-modal__footer">
                    <button type="button" className="btn btn--secondary" onClick={onClose}>
                        Отмена
                    </button>
                    <button
                        type="button"
                        onClick={handleCreate}
                        disabled={loading}
                        className="btn btn--primary"
                    >
                        {loading ? 'Создаём…' : 'Создать и добавить вопросы'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CreatePollModal;
